<section class="w-full py-12 md:py-16">
  <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="text-center items-center mb-10">
      <h2 class="text-3xl md:text-4xl font-semibold tracking-tight">
        {{ 'PAYMENT_TABLE.HEADER' | translate }}
      </h2>

      <!-- Billing Toggle -->
      <div class="mt-6 flex justify-center items-center gap-3">
        <span [class.font-semibold]="billingInterval === 'monthly'" class="text-sm">
          {{ 'PAYMENT_TABLE.BILLING_MONTHLY' | translate }}
        </span>
        <button type="button"
                mat-button
                (click)="toggleBillingInterval()"
                class="!bg-slate-700 !text-white !rounded-full !px-4 !py-2 hover:!bg-slate-600">
          <mat-icon>swap_horiz</mat-icon>
        </button>
        <span [class.font-semibold]="billingInterval === 'yearly'" class="text-sm">
          {{ 'PAYMENT_TABLE.BILLING_YEARLY' | translate }}
          <span class="text-emerald-400 ml-1 text-xs">(spare bis zu 15%)</span>
        </span>
      </div>
    </div>

    <!-- Cards -->
    <div class="grid gap-6 md:gap-8 md:grid-cols-3 items-stretch">
      <mat-card *ngFor="let plan of plans"
                class="relative pt-6 flex flex-col justify-between rounded-2xl border border-slate-800 bg-slate-900/60 backdrop-blur-sm shadow-lg hover:shadow-xl transition-shadow duration-200"
                [ngClass]="{
          'ring-2 ring-emerald-500 shadow-emerald-500/30 scale-[1.01]': plan.popular && !isCurrentPlan(plan),
          'ring-2 ring-blue-500 shadow-blue-500/30 opacity-90': isCurrentPlan(plan)
        }">
        <!-- Popular/Current Badge -->
        <div class="absolute -top-3 left-1/2 -translate-x-1/2 text-[0.7rem] px-3 py-1 rounded-full font-semibold shadow-md"
             [ngClass]="{
            'bg-emerald-500': plan.popular && !isCurrentPlan(plan),
            'bg-blue-500': isCurrentPlan(plan),
            'invisible': !plan.popular && !isCurrentPlan(plan)
          }">
          <ng-container *ngIf="plan.popular && !isCurrentPlan(plan)">
            {{ 'PAYMENT_TABLE.POPULAR' | translate }}
          </ng-container>
          <ng-container *ngIf="isCurrentPlan(plan)">
            {{ 'PAYMENT_TABLE.CURRENT_PLAN' | translate }}
          </ng-container>
        </div>

        <mat-card-content class="p-6 flex flex-col gap-4">
          <div>
            <h3 class="text-lg font-semibold tracking-tight">
              {{ plan.name }}
            </h3>
            <p class="mt-1 text-xs">
              {{ plan.description }}
            </p>
          </div>

          <div class="mt-2">
            <!-- Hauptpreis -->
            <div class="flex items-baseline gap-1">
              <span class="text-2xl md:text-3xl font-bold">
                {{ plan.priceLabel }}
              </span>
            </div>
            <p class="text-[0.7rem] mt-1" *ngIf="plan.priceId != 'FREE'">
              {{
 plan.billingInterval === 'year'
                ? ('PAYMENT_TABLE.BILLING_YEARLY' | translate)
                : ('PAYMENT_TABLE.BILLING_MONTHLY' | translate)
              }}
            </p>

            <!-- Alternativer Preis (Vergleich) -->
            <p class="text-[0.65rem] mt-2 text-gray-400"
               *ngIf="plan.priceId != 'FREE' && plan.alternativePrice">
              {{
 plan.alternativeInterval === 'year'
                ? ('PAYMENT_TABLE.ALTERNATIVE_YEARLY' | translate:{price: plan.alternativePrice})
                : ('PAYMENT_TABLE.ALTERNATIVE_MONTHLY' | translate:{price: plan.alternativePrice})
              }}
            </p>
          </div>

          <div class="mt-4">
            <p class="text-xs font-medium mb-2">
              {{ 'PAYMENT_TABLE.INCLUDES' | translate }}
            </p>
            <ul class="space-y-1.5 text-xs 300">
              <li *ngFor="let feature of plan.features"
                  class="flex items-start gap-2">
                <span class="mt-[2px] h-1.5 w-1.5 rounded-full bg-emerald-400/80"></span>
                <span>{{ feature }}</span>
              </li>
            </ul>
          </div>
        </mat-card-content>

        <mat-card-actions class="px-6 pb-5 pt-1">
          <button type="button"
                  mat-flat-button
                  color="accent"
                  class="w-full !rounded-full !py-2.5 !text-sm font-semibold"
                  [disabled]="isCurrentPlan(plan)"
                  (click)="onSelectPlan(plan)">
            {{ isCurrentPlan(plan) ? ('PAYMENT_TABLE.CURRENT_PLAN' | translate) : ('PAYMENT_TABLE.SELECT_PLAN' | translate) }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- kleine Fußnote -->
    <p class="mt-8 text-[0.7rem] text-center">
      {{ 'PAYMENT_TABLE.FOOTNOTE' | translate }}
    </p>
  </div>
</section>

